export default __webpack_public_path__ + "static/media/DSC_6310-min.8ca18d1c.JPG";